/*!
 * Copyright © 2020-2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { envVarToBoolean } from '@fleetmatics/ui.utilities/validity';

import { Environment } from './environment.interface';

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.

export const environment: Environment = {
  production: true,
  config: {
    apiUrl: '#{API_BASE_URL}',
    revealUrl: '#{REVEAL_URL}',
    pendo: {
      enabled: envVarToBoolean('#{PENDO_ENABLED}'),
      prefix: '#{PENDO_PREFIX}'
    },
    cacheNonce: 1
  }
};
